import { AdvancedImage, placeholder } from '@cloudinary/react';
import { getCloudinaryImage, type CloudinaryImageOptions } from '../lib/cloudinary';

export interface CloudinaryLogoProps extends CloudinaryImageOptions {
  /** Cloudinary cloud name, sourced from the consuming app's env. */
  cloudName: string;
  /** Stored Cloudinary public ID for the logo (e.g. "org-logos/<orgId>"). */
  publicId: string;
  alt?: string;
  className?: string;
}

/**
 * Renders a Cloudinary logo via the React SDK with a predominant-color
 * placeholder, so the badge shows the logo's dominant color immediately
 * instead of a blank box while the full image loads. Sizing/cropping and
 * f_auto/q_auto come from getCloudinaryImage.
 */
export function CloudinaryLogo({
  cloudName,
  publicId,
  alt = '',
  className,
  ...options
}: CloudinaryLogoProps) {
  const image = getCloudinaryImage(cloudName, publicId, options);
  return (
    <AdvancedImage
      cldImg={image}
      plugins={[placeholder({ mode: 'predominant-color' })]}
      alt={alt}
      className={className}
    />
  );
}
